<template>
  <component
    :is="linkExternal ? 'a' : 'router-link'"
    :href="linkExternal ? url : null"
    :to="!linkExternal ? url : null"
    :class="classList"
  >
    <div class="d-flex align-items-center">
      <i :class="icon" /> {{ name }}
      <b-badge
        v-if="badge && badge.text"
        :variant="badge.variant"
      >
        {{ badge.text }}
      </b-badge>
    </div>
  </component>
</template>

<script>
  import { isUrlExternal } from 'is-url-external'

  export default {
    name: 'SidebarNavLink',
    props: {
      name: {
        type: String,
        default: ''
      },
      url: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        default: ''
      },
      badge: {
        type: Object,
        default: () => {}
      },
      variant: {
        type: String,
        default: ''
      }
    },
    computed: {
      classList () {
        return [
          'nav-link',
          this.linkVariant
        ]
      },
      linkVariant () {
        return this.variant ? `nav-link-${this.variant}` : ''
      },
      linkExternal () {
        return isUrlExternal(this.url)
      }
    }
  }
</script>
